import { render, staticRenderFns } from "./UnifiedSearchModal.vue?vue&type=template&id=4a8c40b2&scoped=true"
import script from "./UnifiedSearchModal.vue?vue&type=script&lang=ts"
export * from "./UnifiedSearchModal.vue?vue&type=script&lang=ts"
import style0 from "./UnifiedSearchModal.vue?vue&type=style&index=0&id=4a8c40b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c40b2",
  null
  
)

export default component.exports